import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CreditCardPayment } from 'src/app/admin-api';
import {
  creditCardPaymentTypeLabel,
  subscriberPendingFeeIdLabel
} from 'src/app/utils/payment-display.util';

@Component({
  selector: 'app-payment-details-modal',
  templateUrl: './payment-details-modal.component.html',
  styleUrls: ['./payment-details-modal.component.scss']
})
export class PaymentDetailsModalComponent {
  payment: CreditCardPayment;
  paymentTypeLabel: string;
  pendingFeeIdLabel: string;

  constructor(
    private config: DynamicDialogConfig,
    public ref: DynamicDialogRef
  ) {
    this.payment = this.config.data;
    if (!this.payment)
      throw 'PaymentDetailsModalComponent: please provide payment';
    this.paymentTypeLabel = creditCardPaymentTypeLabel(this.payment);
    this.pendingFeeIdLabel = subscriberPendingFeeIdLabel(
      this.payment.subscriberPendingFeeId
    );
  }
}
